<template>
  <div class="tr-tabs">
    <div class="tr-tabs__header">
      <div
        v-for="(header,index) in headers"
        :key="index"
        @click="headerClick(header,index)"
        class="header-item"
      >{{header.label}}</div>
      <div class="bottom-line" :style="bottomLineStyle"></div>
    </div>
    <slot :active="active"></slot>
  </div>
</template>
<script>
export default {
  props: {
    activeName: ""
  },
  data() {
    return {
      headers: [],
      currentIndex: 0,
      active: this.activeName
    };
  },
  watch: {
    activeName(value) {
      this.active = value;
      this.matchActiveIndex(this.active, this.headers);
    }
  },
  mounted() {
    //初始化header、初始下标
    this.$children.forEach((child, index) => {
      this.headers.push({ label: child.label, name: child.name });
    });
    this.matchActiveIndex(this.active, this.headers);
  },
  methods: {
    //设置下标
    setIndex(index) {
      this.currentIndex = index;
    },
    //设置当前活动页
    setActive(name) {
      this.active = name;
    },
    matchActiveIndex(active, array) {
      array.forEach((item, index) => {
        if (item.name === active) {
          this.currentIndex = index;
        }
      });
    },
    //header点击
    headerClick(item, index) {
      if (item.name === this.active) {
        return;
      }
      this.setIndex(index);
      this.setActive(item.name);
      this.$emit("tabClick", item);
    }
  },
  computed: {
    bottomLineStyle() {
      return {
        left: `${this.currentIndex * 150 + 15}px`
      };
    }
  }
};
</script>
<style lang="less">
.tr-tabs__header {
  display: block;
  position: relative;
  text-align: left;
  padding: 3px 0;
  border-bottom: 2px solid #eceef3;
  .bottom-line {
    position: absolute;
    bottom: -2px;
    width: 120px;
    height: 1px;
    border: 1px solid #57dec1;
    transition: left 0.5s;
  }
  .header-item {
    width: 150px;
    font-size: 22px;
    color: #222222;
    display: inline-block;
    padding: 5px 20px;
    text-align: center;
    cursor: pointer;
  }
}
</style>